import React, { useContext, useCallback, useState } from 'react'
import { generateContext } from '@btime/react-contexts'

const { StateContext, ActionsContext, Provider } = generateContext()
export const useShareDynamicServiceOrder = () => useContext(StateContext)
export const useSetShareDynamicServiceOrder = () => useContext(ActionsContext).setState

export const useCloseShareDynamicServiceOrder = () => {
  const setForm = useSetShareDynamicServiceOrder()
  return useCallback(() => setForm({}), [setForm])
}

export const useOpenShareDynamicServiceOrder = () => {
  const setForm = useSetShareDynamicServiceOrder()
  return useCallback(form => setForm(form), [setForm])
}

const ShareDynamicServiceOrderContext = ({ ...props }) => {
  const [state, setState] = useState({})
  return <Provider state={state} actions={{ setState }} {...props} />
}

export default ShareDynamicServiceOrderContext
